import type { CSSProperties } from 'react'
import { cx } from './cx'

/**
 * A 16px icon drawn in the text colour around it (`currentColor`), for icons on coloured or dark
 * fills (a primary button, a toast's tone) where the kit's Icon (an <img> in the Figma colour)
 * would disappear. The SVG is a mask; any stroke colour in the file is ignored.
 */
export function TintedIcon({ src, className }: { src: string; className?: string }) {
    const style: CSSProperties = {
        maskImage: `url("${src}")`,
        WebkitMaskImage: `url("${src}")`,
        maskSize: '16px 16px',
        WebkitMaskSize: '16px 16px',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
    }
    return <span aria-hidden className={cx('block size-[16px] shrink-0 bg-current', className)} style={style} />
}
